const LandingVideoHero = () => {
  return (
    <section className="py-12 md:py-16 bg-hero-bg">
      <div className="max-w-3xl mx-auto section-padding">
        <div className="text-center mb-8">
          <p className="text-accent font-semibold text-sm tracking-wide uppercase mb-3">
            Real Results from Real Dentists
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-hero-foreground tracking-tight mb-3">
            "I've Gone from a $1.2M Practice to a $2.3M Practice"
          </h2>
          <p className="text-hero-foreground/60 text-sm md:text-base max-w-xl mx-auto">
            Dr. Lejeune broke through his plateau and nearly doubled his collections — with the right strategy and a clear growth plan.
          </p>
        </div>

        <div className="aspect-video rounded-xl overflow-hidden shadow-xl ring-1 ring-border mb-8">
          <iframe
            src="https://www.youtube-nocookie.com/embed/8I-NNGZZD6o?autoplay=1&mute=1&rel=0"
            title="How Dr. Barry Lejeune Grew His Practice Year After Year with Xpress Promotion"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
            loading="eager"
          />
        </div>

        <p className="text-center text-hero-foreground/60 max-w-xl mx-auto leading-relaxed text-sm md:text-base">
          Dr. Lejeune was stuck at $1.2M — working harder but not growing. Your{" "}
          <span className="text-hero-foreground/80 font-medium">Practice Growth Score</span> identifies the exact
          leaks holding you back, so you get a clear plan to break through — just like he did on his way to $2.3M.
        </p>
      </div>
    </section>
  );
};

export default LandingVideoHero;
